type ApiErrorBody = {
  statusCode?: number;
  message?: string;
  title?: string;
  error?: { statusCode?: number; message?: string };
  errors?: Record<string, string[] | string>;
} | null | undefined;

const validationMessages = (errors?: Record<string, string[] | string>) => {
  if (!errors) return "";
  const lines: string[] = [];
  for (const value of Object.values(errors)) {
    if (Array.isArray(value)) lines.push(...value.filter(Boolean));
    else if (value) lines.push(value);
  }
  return lines.join("\n");
};

export function readApiError(httpStatus: number | undefined, body: ApiErrorBody) {
  const e = body?.error ?? body;
  const message =
    e?.message || validationMessages(body?.errors) || body?.title || "";
  return { code: e?.statusCode ?? body?.statusCode ?? httpStatus, message };
}

export function getApiErrorMessage(error: unknown, fallback = ""): string {
  const response = (error as { response?: { status?: number; data?: ApiErrorBody } })
    ?.response;
  if (!response) return fallback;
  return readApiError(response.status, response.data).message || fallback;
}

export function getApiErrorCode(error: unknown): number | undefined {
  const response = (error as { response?: { status?: number; data?: ApiErrorBody } })
    ?.response;
  if (!response) return undefined;
  return readApiError(response.status, response.data).code;
}
